export default "__VITE_ASSET__c3d0ee16__"